import React from "react";
import { observer } from "mobx-react";
import SparkleIcon from "Components/common/SparkleIcon";
import { toasterState } from "Components/common/toaster";
import { BLOCK } from "../agent/agentContract";
import BlockRenderer from "./BlockRenderer";

// Copyable content of an assistant turn: its text blocks, joined. Cards,
// tables and progress rows are UI, not prose — they don't belong on the
// clipboard.
const copyableText = message =>
  (message.blocks || [])
    .filter(block => block.type === BLOCK.TEXT && block.markdown)
    .map(block => block.markdown)
    .join("\n\n")
    .trim();

const MessageRow = observer(({ message }) => {
  if (message.role === "user") {
    return (
      <div className="copilotMsg copilotMsg--user">
        <div className="copilotMsg__userCol">
          <div
            className="copilotMsg__bubble"
            style={message.queued ? { opacity: 0.6 } : undefined}
          >
            {message.text}
          </div>
          {message.queued && (
            <div className="copilotMsg__queuedHint">
              Queued — sending after the current response
            </div>
          )}
        </div>
      </div>
    );
  }

  const text = copyableText(message);
  const handleCopy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => toasterState.setToastMsg("Copied to clipboard", "success"))
      .catch(() => toasterState.setToastMsg("Couldn't copy", "failure"));
  };

  return (
    <div className="copilotMsg copilotMsg--assistant">
      <div className="copilotMsg__avatar">
        <SparkleIcon />
      </div>
      <div className="copilotMsg__content">
        {!message.streaming && text && (
          <button
            type="button"
            className="copilotMsg__copy"
            title="Copy message"
            onClick={handleCopy}
          >
            <i className="material-icons-outlined">content_copy</i>
          </button>
        )}
        {(message.blocks || []).map((block, index) => (
          <BlockRenderer
            key={block.id}
            block={block}
            isStreaming={
              message.streaming && index === message.blocks.length - 1
            }
          />
        ))}
        {message.streaming && !(message.blocks || []).length && (
          <div className="copilotMsg__pending">
            <span className="copilotDot" />
            <span className="copilotDot" />
            <span className="copilotDot" />
          </div>
        )}
      </div>
    </div>
  );
});

export default MessageRow;
